import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { CompanyValues } from '../../../invoicingSettings/types/companyValues'
import { getPrimaryTradeName } from '../../../invoicingSettings/utils/getPrimaryTradeName'
import { InvoicePayloadInvoicer } from '../../types/invoicePayload/invoicePayloadInvoicer'
import { shouldAllowVatNumberWhenExempt } from '../shouldAllowVatNumberWhenExempt'

export const getInvoicerPayload = (
  organization: Organization | undefined,
  companyValues: CompanyValues | undefined,
): InvoicePayloadInvoicer | undefined => {
  if (!organization) {
    return undefined
  }

  const {
    addressLine2,
    city,
    countryId,
    externalId,
    globalId,
    isCegid,
    isVatExempted,
    name,
    registrationNo,
    street,
    vatNo,
    zipcode,
  } = organization

  const defaultTradeName = getPrimaryTradeName(companyValues?.tradeNames)
  const defaultTradeNameLogoId = defaultTradeName?.logo?.id
  const defaultTradeNameLogoUrl = defaultTradeName?.logo?.content
  const defaultTradeNameId = defaultTradeName?._id
  const defaultTradeNameContactPersonName = defaultTradeName?.contact?.name
  const defaultTradeNameEmail = defaultTradeName?.contact.email
  const defaultTradeNamePhone = defaultTradeName?.contact.phone
  const defaultTradeNameMobilePhone = defaultTradeName?.contact.mobilePhone

  const shouldIncludeVatNumber = vatNo && (!isVatExempted || shouldAllowVatNumberWhenExempt(countryId))

  return {
    tradeName: {
      name,
      address: {
        city,
        pobox: zipcode,
        streetAddress1: street,
        streetAddress2: addressLine2,
      },
      contact: {
        name: {
          first: defaultTradeNameContactPersonName?.first || '',
          full: '',
          last: defaultTradeNameContactPersonName?.last || '',
        },
        email: defaultTradeNameEmail || '',
        phone: defaultTradeNamePhone || '',
        mobilePhone: defaultTradeNameMobilePhone || '',
      },
      default: true,
      country: countryId,
      logo: {
        id: defaultTradeNameLogoId || '',
        ...(defaultTradeNameLogoUrl ? { content: defaultTradeNameLogoUrl } : {}),
      },
      ...(defaultTradeNameId ? { _id: defaultTradeNameId } : {}),
    },
    businessId: registrationNo,
    isCegid,
    isNotVATLiable: isVatExempted,
    id: Number(externalId || ''),
    ...(globalId ? { globalId } : {}),
    ...(shouldIncludeVatNumber ? { vatNumber: vatNo } : {}),
  }
}
